import React from 'react';

import { Text } from 'app/shopify/theme';
import { Column, Row } from 'app/shopify/components/layout';

import { IconButton } from './IconButton';

export function IconButtonShowcase() {
  return (
    <Column gap="spacing.general.x4" padding="spacing.general.x4">
      <Text variant="bodySmall" color="text.secondary">
        Icon Button - exemple avec l&apos;icône arrow-right du SVG fourni.
      </Text>

      <Row gap="spacing.general.x3">
        <IconButton accessibilityLabel="Next" variant="primary" size="large" />
        <IconButton accessibilityLabel="Next" variant="secondary" size="large" />
        <IconButton accessibilityLabel="Next" variant="secondaryNeutral" size="large" />
        <IconButton accessibilityLabel="Next" variant="tertiary" size="large" />
        <IconButton accessibilityLabel="Next" variant="ghost" size="large" />
        <IconButton accessibilityLabel="Next" variant="ghostNeutral" size="large" />
      </Row>

      <Row gap="spacing.general.x3">
        <IconButton accessibilityLabel="Next" variant="primary" size="medium" />
        <IconButton accessibilityLabel="Next" variant="primary" size="small" />
        <IconButton accessibilityLabel="Next" variant="primary" size="large" state="hover" />
        <IconButton accessibilityLabel="Next" variant="primary" size="large" state="pressed" />
        <IconButton accessibilityLabel="Next" variant="primary" size="large" state="focus" />
        <IconButton accessibilityLabel="Next" variant="primary" size="large" state="loading" />
      </Row>

      <Row gap="spacing.general.x3">
        <IconButton accessibilityLabel="Next" variant="primary" size="large" inverted />
        <IconButton accessibilityLabel="Next" variant="tertiary" size="large" inverted />
        <IconButton accessibilityLabel="Next" variant="ghost" size="large" inverted />
        <IconButton accessibilityLabel="Next" variant="primary" size="medium" disabled />
      </Row>
    </Column>
  );
}
